import { makeStyles } from "@material-ui/core"

const styles = makeStyles((theme) => ({
  container: {
    maxHeight: "calc(100vh - 140px)",
    overflowY: "auto",

    [theme.breakpoints.down("sm")]: {
      height: "100%",
    },
  },
}))

export default styles
